import React, {Component} from 'react'
import Header4 from 'src/components/Header/Header4';
import './index.css'
import {Button, List, Pagination, message, Modal, Rate, Input, Tooltip} from 'antd';
import {LeftOutlined} from '@ant-design/icons';
import icon_download from '../img/icon_download.png'
import icon_evaluation from '../img/icon_evaluation.png'
import axios from 'axios'
import {connect} from 'react-redux';

const {TextArea} = Input;
const desc = ['差评', '中评', '好评']
const reviewState = {'unExamed': '未审核', 'approve': '审核通过', 'reject': '审核未通过'}
const reviewTip = {'unExamed': '未审核,无法下载', 'reject': '审核未通过,无法下载'}

class DownloadListItemDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderId: null,
            downLoadOrderFilesList: [],
            openIsDownOrderListFlag: false,
            evaluationModalOpen: false,
            evaluationObj: null,
            evaluationStar: null,
            evaluationLoading: false,
            page: 1,
            downloadVisible: false
        }
    }

    componentDidMount() {
        let data = this.props.location.state
        if (data) {
            this.setState({
                orderId: data.orderId,
                downLoadOrderFilesList: data.downLoadOrderFilesList
            }, () => this._downloadVisible(this.state.downLoadOrderFilesList))
            window.localStorage.setItem('orderId', data.orderId)
            window.localStorage.setItem('downLoadOrderFilesList', JSON.stringify(data.downLoadOrderFilesList))
        } else if (window.localStorage.getItem('orderId') && window.localStorage.getItem('downLoadOrderFilesList')) {
            this.setState({
                orderId: window.localStorage.getItem('orderId'),
                downLoadOrderFilesList: JSON.parse(window.localStorage.getItem('downLoadOrderFilesList'))
            }, () => this._downloadVisible(this.state.downLoadOrderFilesList))
        }
        // console.log('下载订单详情:',this.state.orderId, this.state.downLoadOrderFilesList)

    }

    _downloadVisible = (dataList) => {
        console.log('下载列表:', dataList);
        for (const order of dataList) {
            if (order.exam !== 'approve') {
                this.setState({downloadVisible: false});
                return
            }
        }
        this.setState({downloadVisible: true})
    }
    _renderListItem = item => {
        return (
            <div className='produce-order-list-item1'>
                <div className='produce-order-list-item1-left'>
                    <span className='produce-order-list-item1-orderChName'>文件名称: {item.fileName}</span>
                    <div>
                        <span className='produce-order-list-item1-orderSubmitTime'>数据类型: {item.resourceType}</span>
                        <span
                            className='produce-order-list-item1-orderSubmitTime'>订单状态: {item.downloadStatus}</span>
                        <span
                            className='produce-order-list-item1-orderSubmitTime'>下载审核状态: {reviewState[item.exam]}</span>
                    </div>
                </div>
                <div className='download-order-list-item-button-wrapper'>
                    <Tooltip title={reviewTip[item.exam]}>
                        <Button size='small' className='download-order-list-item-button' type="primary"
                                disabled={item.exam !== 'approve'}
                                icon={<img src={icon_download}></img>}
                                onClick={() => this.openClient([item])}>下载</Button>
                    </Tooltip> {item.orderDownloadAddr &&
                    <Button size='small' className='download-order-list-item-button' type="primary"
                            style={{background: 'green'}} icon={<img src={icon_evaluation}></img>}
                            onClick={() => this.setState({
                                evaluationModalOpen: true,
                                evaluationObj: item
                            })}>评价</Button>}
                </div>
            </div>
        )
    }

    downloadMainOrder = (data) => {
        this.openClient(data);
        this.setState({openIsDownOrderListFlag: false})
    }

    openClient = (data) => {
        //通过这个循环保证修改每个订单的下载状态
        console.log('openClient', data)
        let flag = true;
        data.map((item) => {
            if (!item.orderDownloadAddr) {
                flag = false;
            } else
                item.orderDownloadAddr = item.orderDownloadAddr.replace("http://10.0.121.14:8084", "https://caplos.aircas.ac.cn/zdTiles")
        })
        if (!flag) {
            message.error("下载订单内含有没有文件地址的订单，请确认订单完成后重试！");
            return;
        }
        // return;
        let _this = this;
        const linkTmp = document.createElement('a');
        linkTmp.href = 'ydspacebasedbee://';

        linkTmp.onclick = function (e) {
            _this.callapp_openClient({
                data: data,
                callbackTrue: function (dataT) {
                    message.success("准备打开客户端，正在预备下载！");
                    _this.createWSForSimple(data);
                },
                callbackFlase: function () {
                    message.info("检测到本机未安装客户端，请先安装客户端后再下载订单！");
                    const link = document.createElement('a');
                    link.href = 'https://caplos.aircas.ac.cn/oss/group1/M00/1D/FE/rBIAB2bs0R2AVIbLFLridyNmEaw852.exe';
                    link.download = '';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    console.log("客户端打开失败！");
                }
            });
        }
        linkTmp.click();
    }

    //确认客户端是否被打开的回调函数（感觉有点离谱，但是暂时确实想不到更好的办法，好像百度网盘也是类似的逻辑）
    callapp_openClient({data, callbackTrue, callbackFlase}) {
        var t = setTimeout(callbackFlase, 1000);
        var inp = document.createElement("input");
        inp.style.position = "absolute";
        inp.style.clip = "rect(0, 0, 0, 0)";
        // 出现下载框的时候往下跳的问题
        inp.style.top = '0'
        inp.style.left = '0'

        // inp.style.display="none";
        function blur() {
            window.clearTimeout(t);
            callbackTrue(data);
        }

        inp.addEventListener("blur", blur); // 监听blur事件
        document.body.appendChild(inp);
        inp.focus(); // 获取焦点
        setTimeout(function () { // 删除无用的标签
            inp.removeEventListener("blur", blur);
            document.body.removeChild(inp);
        }, 1000);
        //有客户端 如果有本地exe应用，就会弹框，input失去焦点，然后执行blur()事件 清空t定时器 - 删除无用的标签定时器
        //无客户端 不会弹框，input也不会失去焦点 触发t定时器- 执行callback - 删除无用的标签定时器
    }

    createWSForSimple = (data) => {
        let _this = this;
        this.webSocketClient = new WebSocket('ws://127.0.0.1:9312');// 新建一个WebSocket通信，连接一个本地服务器
        this.webSocketClient.onopen = function (e) {             //连接建立时触发函数
            console.log('网站ws通讯已创建，目前状态为：' + _this.webSocketClient.readyState);
            clearInterval(_this.wsTimer);
            _this.setState({wsToClientTimerFlag: true});
            if (_this.webSocketClient.readyState === 1) {
                _this.wsSendMessage(JSON.stringify({
                    type: 'transferToken',
                    data: {token: _this.props.user.token, username: _this.props.user.username}
                }));
                _this.wsSendMessage(JSON.stringify({type: 'download', data: data}));       //传送消息
            }
        }
        this.webSocketClient.onmessage = function (evt) {       //客户端接收服务端数据时触发
            console.log("网站接收到了来自客户端的消息：", evt);//向页面追加显示服务端发送给客户端的消息
        }
        this.webSocketClient.onclose = function (evt) {          //连接关闭时触发
            console.log("网站的连接通关已关闭!", evt);
            if (_this.state.wsToClientTimerFlag) {
                let nowTimer = 0;
                let timeCount = 500;
                let maxTimer = 15000;
                _this.wsTimer = setInterval(() => {
                    _this.createWSForSimple(data);
                    nowTimer += timeCount;
                    console.log("网站尝试连接客户端中，重试：", nowTimer / timeCount);
                    if (nowTimer >= maxTimer) {
                        clearInterval(_this.wsTimer);
                        console.log("网站尝试连接客户端重试结束……");
                    }
                }, timeCount);
                _this.setState({wsToClientTimerFlag: false});
            }
        };

    }

    wsSendMessage = (mes) => {   //向服务端发送消息
        console.log("wsSendMessage", mes);
        this.webSocketClient.send(mes);       //传送消息
    }

    evaluation = () => {
        if (!this.state.evaluationStar) {
            message.warning('请选择评价星级！');
            return
        }

        this.setState({evaluationLoading: true})

        let data = {
            userName: this.props.user.userName,
            downloadOrderFilesId: this.state.evaluationObj.id,
            comments: this.state.evaluationText,
            level: desc[this.state.evaluationStar - 1]
        }

        axios.post('/gateway/api/order-service/order/evaluate/add', data).then(res => {
            message.success("评价成功！")
        })
            .catch(e => {
                message.error("评价失败！")
            })
            .finally(() => {
                this.evaluationClose()
            })
    }

    evaluationClose = () => {
        this.setState({
            evaluationModalOpen: false,
            evaluationText: '',
            evaluationStar: null,
            evaluationObj: {},
            evaluationLoading: false
        })
    }

    render() {
        let {orderId, downLoadOrderFilesList, page, downloadVisible} = this.state
        // console.log(downloadVisible);
        return (
            <div className='Download-list-item-detail'>
                <Header4/>
                <div className='usercenter-main' style={{padding: '0'}}>
                    <div className='usercenter-continer'>
                        <div className='Download-list-item-detail-content'>
                            <div className='Download-list-item-detail-content-header'>
                                <div className='Download-list-item-detail-content-header-left'>
                                    <LeftOutlined className='Download-list-item-detail-content-header-left-back'
                                                  onClick={() => this.props.history.goBack()}/>
                                    <div className='Download-list-item-detail-content-header-left-title'>{orderId}</div>
                                </div>
                                <Tooltip title={!downloadVisible?'存在子订单未通过审核':''}>
                                    <Button type="primary" disabled={!downloadVisible}
                                            onClick={() => this.setState({openIsDownOrderListFlag: true})}>下载</Button>
                                </Tooltip>
                            </div>
                            <div className='Download-list-item-detail-content-list-wrap'>
                                <div className='Download-list-item-detail-content-list'>
                                    <List
                                        dataSource={downLoadOrderFilesList.slice((page - 1) * 10, page * 10)}
                                        renderItem={this._renderListItem}
                                        split={false}
                                        size='small'
                                    />
                                </div>
                                <div className='Download-list-item-detail-content-pagination'>
                                    <Pagination showSizeChanger={false} current={this.state.page}
                                                total={downLoadOrderFilesList.length}
                                                onChange={(page, pageSize) => this.setState({page})}
                                                showTotal={(total) => `共 ${total} 条`}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal visible={this.state.openIsDownOrderListFlag}
                       onOk={() => this.downloadMainOrder(downLoadOrderFilesList)}
                       onCancel={() => this.setState({openIsDownOrderListFlag: false})}>
                    <div className='MyOrder_DLOrderModalContent'>
                        <div className='MyOrder_DLOrderModalText'>订单号：{orderId}</div>
                        <div
                            className='MyOrder_DLOrderModalText'>该订单下子订单数为{downLoadOrderFilesList && downLoadOrderFilesList.length}条，确定下载所有子订单吗？
                        </div>
                    </div>
                </Modal>
                <Modal
                    title='评价'
                    visible={this.state.evaluationModalOpen}
                    onOk={() => {
                        this.evaluation()
                    }}
                    onCancel={() => this.evaluationClose()}
                    className='order-download-modal'
                    confirmLoading={this.state.evaluationLoading}
                >
                    <div style={{marginBottom: '10px'}}>
                        评分：
                        <Rate tooltips={desc} onChange={(e) => {
                            this.setState({evaluationStar: e})
                        }} value={this.state.evaluationStar} count='3'/>
                        {this.state.evaluationStar ?
                            <span className="ant-rate-text">{desc[this.state.evaluationStar - 1]}</span> : ''}
                    </div>
                    <div style={{display: 'flex'}}>
                        <div>评价内容：</div>
                        <TextArea
                            showCount
                            maxLength={50}
                            style={{flex: 1}}
                            value={this.state.evaluationText}
                            onChange={(e) => {
                                this.setState({evaluationText: e.target.value})
                            }}
                            placeholder="评价内容"
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapState = (state) => ({ //返回值  对应的是  组件的props  
    user: state.userReducer.get('user').toJS(), zd_user: state.userReducer.get('zd_user').toJS(),
})
const mapDispatch = (dispatch, ownProps) => ({})

export default connect(mapState, mapDispatch)(DownloadListItemDetail);
